import $ from 'jquery';

/**
 * All used foundation plugins are included here, so only used plugins are loaded.
 * Files can be found inside the "node_modules/foundation-sites/dist/js/plugins" directory.
 */
require( 'foundation-sites/dist/js/plugins/foundation.core' );
require( 'foundation-sites/dist/js/plugins/foundation.dropdownMenu' );
require( 'foundation-sites/dist/js/plugins/foundation.drilldown' );
require( 'foundation-sites/dist/js/plugins/foundation.offcanvas' );
require( 'foundation-sites/dist/js/plugins/foundation.sticky' );
require( 'foundation-sites/dist/js/plugins/foundation.responsiveToggle' );
require( 'foundation-sites/dist/js/plugins/foundation.equalizer');

$( document ).foundation();